import type { SmeCampaignItem, DashboardStat, RecommendedCreator, SmeBrief, SmePackage } from '@/types';

export const dashboardStats: DashboardStat[] = [
  {
    icon: 'lucide:eye',
    name: 'Total Reach',
    percentageChange: '12',
    value: '113300',
  },
  {
    icon: 'lucide:heart',
    name: 'Total Engagement',
    percentageChange: '8',
    value: '8567',
  },
  {
    icon: 'lucide:circle-play',
    name: 'Active campaigns',
    percentageChange: '8',
    value: '1',
  },
  {
    icon: 'lucide:users',
    name: 'Total Creators',
    percentageChange: '+4',
    value: '8',
  },
];

// Dummy creators data for testing the campaign modal

export const smePackages: SmePackage[] = [
  {
    name: 'Launch',
    price: 65000,
    currency: 'KES',
    creators: 2,
    videos: 4,
    reach: '~15K–25K',
    engagementRate: '~6–10%',
    isPopular: false,
  },
  {
    name: 'Boost',
    price: 130000,
    currency: 'KES',
    creators: 4,
    videos: 8,
    reach: '~40K–60K',
    engagementRate: '~6–8%',
    isPopular: true,
  },
  {
    name: 'Scale',
    price: 265000,
    currency: 'KES',
    creators: 8,
    videos: 16,
    reach: '~80K–120K',
    engagementRate: '~5–7%',
    isPopular: false,
  },
  {
    name: 'Platinum',
    price: 500000,
    currency: 'KES',
    creators: 15,
    videos: 30,
    reach: '~160K–240K',
    engagementRate: '~4–6%',
    isPopular: false,
  },
];
